module.exports = __webpack_public_path__ + "static/media/checkbox-filled.c905a192.svg";